"use client";
import { SpinLoading } from "antd-mobile";
const Loading = () => {
    return (
        <div className="loading">
            <SpinLoading />
        </div>
    );
};
export default Loading;
